var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"color":"primary","label":_vm.lc.label,"to":_vm.addDomainPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }